import React, { useState } from 'react';
import { Search as SearchIcon } from 'lucide-react';
import { articleService } from '../services/api';

function Search() {
  const [articles, setArticles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setHasSearched(true);

    try {
      const response = await articleService.getAll();
      const filtered = response.data.filter(article =>
        article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.abstract.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.keywords.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setArticles(filtered);
    } catch (error) {
      console.error('Error searching:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">جستجو</h1>
          <p className="text-xl text-blue-100">جستجو در مقالات نشریه</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <form onSubmit={handleSearch} className="mb-12">
          <div className="bg-white rounded-xl shadow-md p-8">
            <div className="flex gap-3">
              <div className="flex-1 relative">
                <SearchIcon className="absolute right-4 top-3.5 text-gray-400" size={20} />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="جستجو در عنوان، چکیده و کلمات کلیدی..."
                  className="w-full pr-12 pl-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                />
              </div>
              <button
                type="submit"
                className="bg-gradient-to-r from-blue-700 to-blue-900 text-white px-8 py-3 rounded-lg font-bold hover:from-blue-800 hover:to-blue-950 transition shadow-lg hover:shadow-xl flex items-center gap-2"
              >
                <SearchIcon size={20} />
                جستجو
              </button>
            </div>
          </div>
        </form>

        {loading && (
          <div className="text-center py-12 text-gray-500">در حال جستجو...</div>
        )}

        {hasSearched && !loading && (
          <div>
            <p className="text-gray-600 font-medium mb-6">
              {articles.length} نتیجه برای "{searchTerm}" پیدا شد
            </p>

            {articles.length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                هیچ نتیجه‌ای برای جستجوی شما پیدا نشد
              </div>
            ) : (
              <div className="space-y-4">
                {articles.map((article) => (
                  <div
                    key={article.id}
                    className="bg-white rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-md transition p-6"
                  >
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{article.title}</h3>
                    <p className="text-gray-600 text-sm mb-3 line-clamp-2">{article.abstract}</p>
                    <div className="flex justify-between items-center text-sm text-gray-500">
                      <span>{article.articleAuthors?.map(aa => aa.author.firstName + ' ' + aa.author.lastName).join('، ')}</span>
                      <span>{new Date(article.submissionDate).toLocaleDateString('fa-IR')}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Search;
